module.exports = __webpack_public_path__ + "img/15600.5d81dc24.jpg";